export enum StockRecordEnum {
    ADD = "ADD",
    DEDUCT = "DEDUCT",
    MOVE_IN = "MOVE_IN",
    MOVE_OUT = "MOVE_OUT"
}